import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=844e7d52&"
import script from "./app-footer.vue?vue&type=script&lang=ts&"
export * from "./app-footer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844e7d52')) {
      api.createRecord('844e7d52', component.options)
    } else {
      api.reload('844e7d52', component.options)
    }
    module.hot.accept("./app-footer.vue?vue&type=template&id=844e7d52&", function () {
      api.rerender('844e7d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app-footer.vue"
export default component.exports